module.exports = __webpack_public_path__ + "img/delete-illustration.9e9fb04c.png";